import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import dictData from 'dictionary';
import HomeSectionHeader from 'components/pages/home/HomeSectionHeader';
import { AnimationHomeInternetDelivery } from 'components/pages/home/animations';
import internetDeliveryImage from 'images/home-internet-delivery.jpg';
import routeList from 'routes/routeList';

const HomeInternetDelivery: React.FC = () => {
  useEffect(AnimationHomeInternetDelivery, []);

  return (
    <section className="home-internet-delivery-wrapper">
      <div className="content-wrapper">
        <Row className="home-internet-delivery-row">
          <Col lg={5}>
            <img src={internetDeliveryImage} alt="" className="home-internet-delivery-img" />
          </Col>
          <Col lg={6}>
            <HomeSectionHeader
              subtitle="Internet OSE"
              title={dictData.home.internetDeliverySection.title}
              description={dictData.home.internetDeliverySection.description}
              linkTo={routeList.oseInternet}
            />
          </Col>
        </Row>
        <Row className="home-internet-delivery-features-row">
          {dictData.home.internetDeliverySection.features.map((item, id) => {
            const AnimationComponent = item.animationIcon;
            return (
              <Col xs={12} lg={4} key={id}>
                <div className="home-internet-delivery-feature">
                  <AnimationComponent className={`hid-icon-${id}`} />
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </Col>
            );
          })}
          <div className="home-internet-delivery-floating-text" aria-hidden="true">
            <span>Internet</span>
          </div>
        </Row>
      </div>
    </section>
  );
};

export default HomeInternetDelivery;
